import {
  CacheProvider,
  createEmotionCache,
  CssBaseline,
  EmotionCache,
  ThemeProvider,
} from '@pogokid/mui'
import { PropsWithChildren } from 'react'
import { soniqStylesTheme } from '~/theme'
import { ErrorBoundary } from '~m/AppUi/components/ErrorBoundary.tsx'

// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache()

interface LayoutProps {
  emotionCache?: EmotionCache
}

const theme = soniqStylesTheme()

export default function ClientLayout({
  children,
  emotionCache = clientSideEmotionCache,
}: PropsWithChildren<LayoutProps>) {
  return (
    <CacheProvider value={emotionCache}>
      <ThemeProvider theme={theme} defaultMode="system">
        <CssBaseline />
        <ErrorBoundary>{children}</ErrorBoundary>
      </ThemeProvider>
    </CacheProvider>
  )
}
